import React, {
  ChangeEvent,
  MouseEvent,
  useEffect,
  useMemo,
  useState,
} from 'react';
import styled from 'styled-components';
import {
  Panel,
  Label,
  FormControl,
  Checkbox,
  Button,
  Card,
  TextInput,
  RadioButton,
  Dropdown,
  IDropdownItem,
  Select,
} from '@uhg-harmony/uitk-react';
import { Arrow } from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import { Config } from './types';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import {
  BackgroundData,
  Background,
  ColorButtonWrapper,
} from 'builder/components/WidgetConfigurations/Background/Background';
import {
  FieldWrapper,
  StyledLabel,
} from 'builder/components/WidgetConfigurations/TextInput/TextInputPanel';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from 'builder/components/WidgetSizeLocation';
import {
  StyledClose,
  StyledPickerHeader,
  StyledPickerPopover,
  StyledPickerWrapper,
} from 'builder/components/GradientColorPicker/GradientColorPicker';
import {
  ButtonWrapperFolder,
  StyledAddItemButton,
  StyledAlternativeButton,
  StyledSettingName,
  StyledSettingsCard,
  StyledTextName,
  StyledTitle,
  dividerStyles,
  iconStyle,
  settingsDividerStyles,
  ButtonWrapper,
  StyledIcon,
} from 'builder/scenes/SiteBuilder/PagesPanel/PagesPanel';
import { AddIcon } from '@uhg-harmony/uitk-icons-react';
import { Divider, Popover } from '@material-ui/core';
import {
  UncontrolledTreeEnvironment,
  Tree,
  StaticTreeDataProvider,
} from 'react-complex-tree';
import 'react-complex-tree/lib/style-modern.css';
import { useEventSubscriber } from 'use-event-emitter-hook';
import { navRenderers } from 'builder/scenes/SiteBuilder/navRenderers';
import { NavLink } from '../shared/types';
import S3Image from 'builder/components/S3Image';
import LogoPreview from 'builder/components/WidgetConfigurations/Background/LogoPreview';
import {
  Padding,
  PaddingData,
} from 'builder/components/WidgetConfigurations/Padding';
import { ColorLabelStyles } from 'builder/components/WidgetConfigurations/Dropdown/DropdownPanel';
import { defaultTheme as theme } from 'shared/theme/theme';
import {
  IDP_VALUES_TO_USE,
  lineDirectionOptions,
} from 'builder/util/constants';
import EnableFullScreenWidth from 'builder/components/WidgetConfigurations/EnableFullScreenWidth';
import { ColorButton } from 'builder/components/ColorButton/ColorButton';
import { StyledPanel, StyledPanelTitle } from '../Text/TextWidgetControl';
import { MainLabelStyles } from 'builder/components/WidgetConfigurations/Typography/Typography';
import { NavigationTypography } from './NavigationTypography';
import GradientColorPicker from 'builder/components/GradientColorPicker/GradientColorPicker';
import { toast } from 'react-toastify';
// Alias Icon to avoid duplicate identifier collisions in this module
import { Icon as SharedIcon } from 'shared/theme/link-ui-react/Icon';
import { StyledResponse } from '../Form/FormBlock/FormWidgetControl';
import {
  sortItems,
  handleDropRequiredItem,
  generateRoutingSnippet,
  getTopLevelParentRoutingId,
  generateDefaultRoutingId,
  getNextNavItemId,
  removeNavItemWithDescendants,
  resolveDropParentId,
  PLACEHOLDER_OFFSET,
  buildPlaceholderTreeItem,
} from './NavWidgetControl.util';

export {
  sortItems,
  handleDropRequiredItem,
  generateRoutingSnippet,
  getTopLevelParentRoutingId,
  generateDefaultRoutingId,
  getNextNavItemId,
  removeNavItemWithDescendants,
  resolveDropParentId,
  PLACEHOLDER_OFFSET,
  buildPlaceholderTreeItem,
} from './NavWidgetControl.util';

export const DividerLabelStyle = {
  color: '#1d1929',
  fontSize: '14px',
  fontFamily: 'OptumSans',
  fontWeight: '500',
};

const StyledTextInput = styled(TextInput)`
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem;
  color: #4b4d4f;
  font-family: OptumSans, sans-serif;
  font-size: 0.875em;
`;

const OrientationSelect = styled(Select)`
  border-radius: 0.375rem;
  margin-left: 1em;
  #orientation-select {
    width: 10em;
    font-family: OptumSans, sans-serif;
    line-height: 1.25rem;
    box-shadow: 0 0 0 1px ${theme.colors.aux.black};
    font-size: 14px;
    margin-right: -0.5em;
  }
`;

const StyledFormLabel = styled(Label)`
  color: #333333;
  font-size: 0.875em;
  font-family: OptumSans, sans-serif;
  padding: 0.5em 0.5em 0.5em 0;
`;

const StyledFormIDPLabel = styled(Label)`
  color: #333333;
  font-size: 0.8em;
  font-family: OptumSans, sans-serif;
  padding: 0.5em 0.5em 0.5em 0;
`;

const LineDirectionWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
`;

const Form = <StyledIcon icon="Form" width={15} />;

const StyledDiv = styled.div`
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;
const StyledPage = styled.div``;

const StyledCheckBox = styled(Checkbox)`
  margin: -8px 0;
  font-family: OptumSans, sans-serif;
  font-size: 11pt;
`;

const StyledRadioButton = styled(RadioButton)`
  font-family: OptumSans, sans-serif;
  color: #000000;
  font-size: 12pt;
  font-weight: 700;
  margin-bottom: 0.75rem;
  align-items: flex-start;
  & > input[type='radio'] {
    margin-top: 0.2rem;
    flex-shrink: 0;
  }
  & > label {
    display: flex;
    align-items: flex-start;
    font-family: OptumSans, sans-serif;
  }
`;

const ColorButtonAndLabelWrapper = styled.div`
  display: inline-flex;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-self: baseline;
  margin-top: 0.5rem;
`;

const InlineMainLabel = styled(MainLabelStyles)`
  margin-right: 1.15rem;
  white-space: nowrap;
`;

const StyledCheckbox = styled(Checkbox)`
  display: flex;
  flex-wrap: wrap;
  padding-left: 1rem;
  & > label {
    margin: 0;
  }
`;

const StyledCard = styled.div`
  width: 24em;
  & div[class^='Cardcomponent__Content'] {
    margin-top: -5px;
    display: grid;
  }
  & .uitk-card {
    width: inherit;
  }
`;

const StyledPopover = styled(Popover)`
  margin-top: -14px;
  .MuiPaper-root {
    overflow-x: unset;
    overflow-y: unset;
  }
`;

const StyledEditPopover = styled(Popover)`
  margin-top: -14px;
  .MuiPaper-root {
    overflow-x: unset;
    overflow-y: unset;
  }
`;

export const StyledFormControl = styled(FormControl)`
  border: none;
  width: 100%;
`;

const StyledHeader = styled.div`
  padding-bottom: 0.5rem;
  font-weight: 700;
  font-family: OptumSans, sans-serif;
`;

const SecondaryFormControl = styled(FormControl)`
  width: 15em;
  border: none;
`;

export const StyledDropdown = styled(Dropdown)`
  && {
    width: 100%;
    box-sizing: border-box;
    line-height: 1.25rem;
    font-family: OptumSans, sans-serif;
    font-size: 0.875em;
  }
`;

const ButtonWrapper1 = styled.div`
  display: flex;
  .uitk-button {
    margin-right: 7px;
    margin-top: 2rem;
    font-family: OptumSans, sans-serif;
  }
  .mt-base {
    width: auto;
  }
`;

const SizeLocationPanel = styled(Panel)`
  > div {
    padding: 1rem;
  }
`;

const StyledSubtext = styled.div`
  font-size: 11pt;
  font-weight: 400;
  padding: 0.5rem 0;
`;

const S3ImageControlsWrapper = styled.div`
  font-family: OptumSans, sans-serif;
  font-size: 9pt;
  padding-top: 4px;
  display: flex;
  & .MUIButtonBase-root {
    font-family: OptumSans, sans-serif;
  }
  & > div > div > label > button {
    font-family: OptumSans, sans-serif;
  }
`;

const S3ImagePreviewWrapper = styled.div`
  padding-top: 10px;
`;

const StyledNewLink = {
  width: 'inherit',
};

const StyledRequiredCheckbox = styled(Checkbox)`
  padding-top: 5px;
`;

const missingPageSelectionError =
  'Selected page could not be found. Please choose another page.';

const initialCurrentItemState: NavLink = {
  id: null,
  displayText: '',
  url: '',
  icon: { alt: '', url: '' },
  visible: true,
  selectedIdps: [],
  type: 'none',
  pageSelected: null,
  isSection: false,
  parentSectionId: null,
  childOrder: [],
  required: false,
  routingId: '',
};

type SavedPageReference = {
  id?: number | string;
  title?: string;
  slug?: string;
  current?: Pick<PageVersion, 'slug' | 'title'>;
};

type MinimalPageReference = {
  id: number;
  current: Pick<PageVersion, 'slug' | 'title'>;
};

/**
 * Extracts the numeric id from a page reference or dropdown item.
 * Returns undefined if id is not a valid number.
 */
/**
 * Extracts the numeric page ID from a page reference or dropdown item.
 * Returns undefined if the ID is not valid.
 */
const getPageReferenceId = (
  pageReference?: SavedPageReference | IDropdownItem | null
): number | undefined => {
  const id = Number(pageReference?.id);
  return Number.isNaN(id) ? undefined : id;
};

/**
 * Returns a minimal page reference object containing only id and current (slug, title).
 */
/**
 * Returns a minimal page reference containing only the ID and current slug/title.
 */
const getMinimalPageReference = (page: Page): MinimalPageReference => ({
  id: page.id,
  current: { slug: page.current.slug, title: page.current.title },
});

/**
 * Finds the dropdown item corresponding to a given page reference from the dropdown list.
 * Returns null if not found.
 */
/**
 * Finds the dropdown item corresponding to a given page reference.
 * Returns null if not found.
 */
const getPageDropdownItem = (
  pageReference: SavedPageReference | IDropdownItem | null | undefined,
  pageDropdown: IDropdownItem[]
): IDropdownItem | null => {
  const selectedPageId = getPageReferenceId(pageReference);
  if (selectedPageId == null) {
    return null;
  }
  return (
    pageDropdown.find(
      item => Number(item.value ?? item.id) === selectedPageId
    ) || null
  );
};

/**
 * Returns the insertion index for a 'between-items' drop target.
 * Falls back to the provided value for non-between-items targets or when childIndex is absent.
 * @param target - The drop target from react-complex-tree
 * @param fallback - Index to use when the target is not 'between-items' or has no childIndex
 * @returns The resolved insertion index
 */
const getBetweenItemsInsertIndex = (target: any, fallback: number): number =>
  target.targetType === 'between-items' && typeof target.childIndex === 'number'
    ? target.childIndex
    : fallback;

/**
 * Resolves the new parent ID from a drop target.
 * Returns null when the item is dropped at root level.
 * @param target - The drop target from react-complex-tree
 * @returns The numeric parent item ID, or null for root-level drops
 */
const getNewParentId = (target: any): number | null => {
  if (target.targetType === 'item') return target.targetItem;
  if (target.targetType === 'between-items')
    return target.parentItem == null || target.parentItem === 'root'
      ? null
      : target.parentItem;
  return null;
};

/**
 * Rebuilds the root-level treeOrder array after a drag-and-drop operation.
 * Handles the four transition cases: root→section, section→root, root→root reorder,
 * and section→section (no root-order change needed).
 * @param treeOrder - Current root-level ordering of item IDs
 * @param draggedId - ID of the item being moved
 * @param prevParentId - Parent ID before the drag, or null if the item was at root
 * @param newParentId - Parent ID after the drag, or null if the item is dropped at root
 * @param target - The drop target from react-complex-tree (used for position within root)
 * @returns Updated treeOrder array
 */
const recomputeTreeOrder = (
  treeOrder: number[],
  draggedId: number,
  prevParentId: number | null,
  newParentId: number | null,
  target: any
): number[] => {
  if (prevParentId === null && newParentId !== null) {
    // moved from root into a section — remove from root order
    return treeOrder.filter(id => id !== draggedId);
  }
  if (prevParentId !== null && newParentId === null) {
    // moved from a section to root — add to root order
    const order = [...treeOrder];
    if (!order.includes(draggedId)) {
      order.splice(
        getBetweenItemsInsertIndex(target, order.length),
        0,
        draggedId
      );
    }
    return order;
  }
  if (prevParentId === null && newParentId === null) {
    // reordering within root — update position
    const order = treeOrder.filter(id => id !== draggedId);
    order.splice(
      getBetweenItemsInsertIndex(target, order.length),
      0,
      draggedId
    );
    return order;
  }
  return [...treeOrder];
};

// drag-and-drop logic: updates parentSectionId and childOrder for moved items, then rebuilds treeOrder from dataProvider.
export const handleDrop = (item, target, props) => {
  if (!Array.isArray(item) || item.length === 0 || item[0]?.data?.id == null) {
    return;
  }
  if (!target || typeof target !== 'object') {
    return;
  }
  if (!Array.isArray(props?.widgetState?.config?.menuItems)) {
    return;
  }

  let updatedMenuItems = [...props.widgetState.config.menuItems];
  const draggedId = item[0].data.id;
  const draggedItemIndex = updatedMenuItems.findIndex(i => i.id === draggedId);
  if (draggedItemIndex === -1) {
    return;
  }
  const draggedItem = updatedMenuItems[draggedItemIndex];

  const prevParentId = draggedItem.parentSectionId ?? null;
  const rawParentId = getNewParentId(target);
  const newParentId = resolveDropParentId(
    rawParentId,
    target,
    updatedMenuItems,
    props.widgetState.config.treeOrder,
    prevParentId,
    draggedItem.isSection
  );

  updatedMenuItems = updatedMenuItems.map(menuItem => {
    if (menuItem.id === newParentId && Array.isArray(menuItem.childOrder)) {
      const childOrder = menuItem.childOrder.filter(id => id !== draggedId);
      childOrder.splice(
        getBetweenItemsInsertIndex(target, childOrder.length),
        0,
        draggedId
      );
      return { ...menuItem, childOrder };
    }
    if (menuItem.id === prevParentId && Array.isArray(menuItem.childOrder)) {
      return {
        ...menuItem,
        childOrder: menuItem.childOrder.filter(id => id !== draggedId),
      };
    }
    return menuItem;
  });
  updatedMenuItems[draggedItemIndex] = {
    ...draggedItem,
    parentSectionId: newParentId,
  };

  props.onChange({
    ...props.value,
    menuItems: updatedMenuItems,
    treeOrder: recomputeTreeOrder(
      props.widgetState.config.treeOrder,
      draggedId,
      prevParentId,
      newParentId,
      target
    ),
  });
};

const NavWidgetControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    pages,
    removeWidget,
    isEditingTemplate,
    currentPage: { layoutLocked },
  } = props;

  const typeDropdown: IDropdownItem[] = [
    { id: 'none', label: 'None', value: 'none' },
    { id: 'page', label: 'Page', value: 'page' },
    { id: 'url', label: 'URL', value: 'url' },
  ];

  const [selectedType, setSelectedType] = useState<IDropdownItem>(
    typeDropdown[0]
  );

  const pageDropdown: IDropdownItem[] = useMemo(
    () =>
      (pages ?? [])
        .filter(page => page.current.slug !== 'defaultContentPage')
        .map(page => ({
          id: page.id,
          label: page.current.title,
          value: page.id,
        })),
    [pages]
  );

  const [idpDropdown, setIdpDropdown] = useState<IDropdownItem[]>([]);

  const [pickerAnchorEl, setPickerAnchorEl] = useState<HTMLDivElement | null>(
    null
  );
  const pickerOpen = Boolean(pickerAnchorEl);
  const pickerId = pickerOpen ? 'simple-popover' : undefined;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const createLinkOpen = Boolean(anchorEl);
  const id = createLinkOpen ? 'simple-popover' : undefined;
  const [itemType, setItemType] = useState('');
  const [checked, setChecked] = useState('');
  const [_editTreeOpen, setEditTreeOpen] = useState(false);
  const [isEditingSection, setIsEditingSection] = useState(false);
  const [isEditingLink, setIsEditingLink] = useState(false);
  const [changed, setChanged] = useState(0);

  // Increment changed whenever menuItems updates in Redux so the tree
  // remounts *after* the new data is available — not before (race condition).
  useEffect(() => {
    setChanged(prev => prev + 1);
  }, [widgetState.config.menuItems]);
  const [
    editSectionAnchorEl,
    setEditSectionAnchorEl,
  ] = useState<SVGElement | null>(null);
  const editSectionOpen = Boolean(editSectionAnchorEl);
  const editItemId = editSectionOpen ? 'edit-link-popover' : undefined;
  const [openEditLink, setOpenEditLink] = useState(false);
  const [currentItem, setCurrentItem] = useState<NavLink>(
    initialCurrentItemState
  );
  const [pageValue, setPageValue] = useState(null);
  const [selectedIdps, setSelectedIdps] = useState([]);
  const initialFormValues = {
    newDisplayText: '',
    newIcon: { url: '', alt: '' },
    newUrl: '',
    newVisible: true,
    newIdps: [],
    newPageSelected: null,
    newType: 'none',
    newRequired: false,
    newRoutingId: '',
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [openPopover, setOpenPopover] = useState({
    linkForm: false,
    sectionForm: false,
    optionsMenu: false,
  });

  const handleSelectedIdps = (items: IDropdownItem[]) => {
    setSelectedIdps(items);
  };

  const updateFormValues = (updates: Partial<typeof initialFormValues>) => {
    setFormValues(prev => ({
      ...prev,
      ...updates,
    }));
  };

  const resetForm = () => {
    setFormValues(initialFormValues);
    setSelectedType(typeDropdown[0]);
    setSelectedIdps([]);
    setPageValue(null);
  };

  const resetAddItemState = () => {
    resetForm();
    setCurrentItem(initialCurrentItemState);
    setIsEditingSection(false);
    setIsEditingLink(false);
    setOpenEditLink(false);
  };

  const resetPopovers = () => {
    setOpenPopover({
      linkForm: false,
      sectionForm: false,
      optionsMenu: false,
    });
    setAnchorEl(null);
    setEditSectionAnchorEl(null);
    setOpenEditLink(false);
    setChecked('');
  };

  const setLinkFormOpen = (isOpen: boolean) => {
    setOpenPopover(prev => ({
      ...prev,
      linkForm: isOpen,
    }));
  };

  const updateWidgetConfig = (updates: Partial<Config>) => {
    onChange({
      ...value,
      ...updates,
    });
  };

  useEventSubscriber('editClick', value => {
    setEditTreeOpen(value.isEditClicked);
    setEditSectionAnchorEl(value.eventTarget);
    setIsEditingSection(value.isSection);
    setIsEditingLink(!value.isSection);
    setCurrentItem({
      id: value.itemData.id,
      displayText: value.itemData.displayText,
      url: value?.itemData?.url,
      type: value?.itemData?.type,
      pageSelected: value?.itemData?.pageSelected,
      icon: {
        alt: value?.itemData?.icon?.alt,
        url: value?.itemData?.icon?.url,
      },
      visible: value.itemData.visible,
      parentSectionId: value?.itemData?.parentSectionId,
      childOrder: value?.itemData?.childOrder,
      selectedIdps: value?.itemData?.selectedIdps,
      required: value?.itemData?.required,
      routingId: value?.itemData?.routingId || '',
    });
  });

  useEffect(() => {
    if (currentItem.id === null) return;

    setFormValues({
      newDisplayText: currentItem.displayText,
      newUrl: currentItem.url,
      newVisible: currentItem.visible,
      newIcon: { alt: currentItem.icon.alt, url: currentItem.icon.url },
      newPageSelected: currentItem.pageSelected,
      newIdps: currentItem.selectedIdps,
      newType: currentItem.type,
      newRequired: currentItem.required,
      newRoutingId: currentItem.routingId || '',
    });
    setSelectedType(
      typeDropdown[
        typeDropdown.findIndex(type => type.value === currentItem.type)
      ]
    );
    setPageValue(getPageDropdownItem(currentItem.pageSelected, pageDropdown));
    if (Array.isArray(currentItem.selectedIdps) && idpDropdown.length > 0) {
      const mappedIdps = currentItem.selectedIdps
        .map((idp: any) => {
          if (typeof idp === 'string') {
            return idpDropdown.find(d => d.value === idp);
          }
          if (idp && typeof idp === 'object' && 'value' in idp) {
            return idpDropdown.find(d => d.value === idp.value);
          }
          return undefined;
        })
        .filter(Boolean);
      setSelectedIdps(mappedIdps);
    } else {
      setSelectedIdps([]);
    }
  }, [currentItem, idpDropdown, pageDropdown]);

  useEffect(() => {
    setIdpDropdown(
      IDP_VALUES_TO_USE.map(idp => ({
        id: idp.alias,
        label: idp.displayName,
        value: idp.alias,
      })).filter(idp => idp.value !== '')
    );
  }, []);

  const updateWidgetSizeLocation = (sizeLoc: SizeLocationData) => {
    updateWidgetConfig({
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
      menuItems: widgetState.config.menuItems,
    });
  };

  const updateBorderData = (data: BorderData) => {
    updateWidgetConfig({ borderData: data });
  };

  const backgroundData = (data: BackgroundData) => {
    updateWidgetConfig({ backgroundData: data });
  };

  const updatePaddingData = (data: PaddingData) => {
    updateWidgetConfig({ paddingData: data });
  };

  const updateBackgroundImage = (data: Image) => {
    updateWidgetConfig({ backgroundImage: data });
  };

  const handleLineColor = data => {
    updateWidgetConfig({ lineColor: data });
  };

  const handleColorEditClick = (
    e: MouseEvent<HTMLDivElement>,
    type: string
  ) => {
    if (layoutLocked) return;
    e.stopPropagation();
    e.preventDefault();
    setPickerAnchorEl(e.currentTarget);
    setItemType(type);
  };

  const handlePickerClick = (e: MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handlePickerClose = (e: MouseEvent<any>) => {
    e.stopPropagation();
    setPickerAnchorEl(null);
  };

  const isGradientColor = (color: string) =>
    color.startsWith('linear') || color.startsWith('radial');

  const showGradientWarning = (colorLabel: string) => {
    toast(`Gradient cannot be used for ${colorLabel}`, {
      type: 'warning',
      theme: 'colored',
    });
  };

  const applySolidColorValue = (
    configKey: keyof Config,
    newColor: string,
    colorLabel: string
  ) => {
    if (isGradientColor(newColor)) {
      showGradientWarning(colorLabel);
      return;
    }

    updateWidgetConfig({ [configKey]: newColor });
  };

  const handleColorChange = newColor => {
    const colorTargetByElementId: Record<
      string,
      { configKey: keyof Config; colorLabel: string }
    > = {
      'icon-color': { configKey: 'iconColor', colorLabel: 'icon color' },
      'divider-color': {
        configKey: 'dividerLineColor',
        colorLabel: 'divider color',
      },
      'vertical-divider-color': {
        configKey: 'verticalDividerLineColor',
        colorLabel: 'vertical divider color',
      },
      'text-color': { configKey: 'textColor', colorLabel: 'text color' },
    };

    const targetConfig =
      colorTargetByElementId[pickerAnchorEl?.id ?? ''] || undefined;

    if (!targetConfig) {
      return;
    }

    applySolidColorValue(
      targetConfig.configKey,
      newColor,
      targetConfig.colorLabel
    );
  };

  const handleDividerCheck = (e: ChangeEvent<HTMLInputElement>) => {
    updateWidgetConfig({ showDividerLines: e.target.checked });
  };

  const handleVerticalDividerCheck = (e: ChangeEvent<HTMLInputElement>) => {
    updateWidgetConfig({ showVerticalDivider: e.target.checked });
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    resetAddItemState();
    setOpenPopover(prev => ({
      ...prev,
      linkForm: false,
    }));
    setChecked('');
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: MouseEvent<any>) => {
    e.stopPropagation();
    e.preventDefault();
    resetForm();
    resetPopovers();
  };

  const handleInputClick = (e: MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };

  const setValue = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.value);
  };

  const openPanel = (e: MouseEvent<any>) => {
    e.stopPropagation();
    e.preventDefault();
    resetAddItemState();
    setLinkFormOpen(true);
  };

  const closePanel = (e: MouseEvent<any>) => {
    e.stopPropagation();
    e.preventDefault();
    resetForm();
    setLinkFormOpen(false);
  };

  const handleUrl = (e: ChangeEvent<HTMLInputElement>) => {
    if (selectedType?.value === 'url') {
      updateFormValues({ newUrl: e.target.value });
    }
    if (selectedType?.value === 'none') {
      updateFormValues({ newUrl: '' });
    }
  };

  const handleBackgroundColor = (data: string) => {
    onChange({
      ...value,
      backgroundData: {
        ...value.backgroundData,
        color: data,
      },
    });
  };

  const handleFullScreen = (data: boolean) => {
    updateWidgetConfig({ enableFullScreen: data });
  };

  const emptyFolderIds = useMemo(
    () =>
      widgetState.config.menuItems
        .filter(
          item =>
            item.isSection &&
            Array.isArray(item.childOrder) &&
            item.childOrder.length === 0
        )
        .map(item => item.id),
    [widgetState.config.menuItems]
  );

  const transformedData: Record<string, any> = {
    root: {
      index: 'root',
      isFolder: true,
      children: widgetState.config.treeOrder.filter(id =>
        widgetState.config.menuItems.some(
          item => item.id === id && !item.parentSectionId
        )
      ),
      data: 'Root item',
    },
  };

  widgetState.config.menuItems.forEach(item => {
    const sectionChildOrder = item.childOrder || [];
    const realChildren = widgetState.config.menuItems
      .filter(childItem => childItem.parentSectionId === item.id)
      .sort(
        (a, b) =>
          (sectionChildOrder.includes(a.id)
            ? sectionChildOrder.indexOf(a.id)
            : Number.MAX_SAFE_INTEGER) -
          (sectionChildOrder.includes(b.id)
            ? sectionChildOrder.indexOf(b.id)
            : Number.MAX_SAFE_INTEGER)
      )
      .map(childItem => childItem.id);

    // Inject a synthetic placeholder child into empty section folders so
    // react-complex-tree has a real DOM element to detect drops against.
    // The placeholder only exists in the tree data — it is never saved to Redux.
    if (item.isSection && realChildren.length === 0) {
      const placeholderId = PLACEHOLDER_OFFSET + item.id;
      realChildren.push(placeholderId);
      transformedData[placeholderId] = buildPlaceholderTreeItem(item.id);
    }

    transformedData[item.id] = {
      index: item.id,
      isFolder: !!item.isSection,
      children: realChildren,
      data: item,
      canMove: true,
    };
  });

  const dataProvider = new StaticTreeDataProvider(
    transformedData,
    (item, newName) => ({
      ...item,
      data: newName,
    })
  );

  const getSharedNavItemFields = () => ({
    displayText: formValues.newDisplayText,
    visible: formValues.newVisible,
    icon: formValues.newIcon,
    required: formValues.newRequired,
    selectedIdps: selectedIdps || [],
    routingId:
      selectedType?.value === 'none' ? formValues.newRoutingId : undefined,
  });

  const persistMenuItems = (
    updatedMenuItems: NavLink[],
    options?: { updatedTreeOrder?: number[]; changedId?: number | null }
  ) => {
    const nextValue: Config = {
      ...value,
      menuItems: updatedMenuItems,
    };

    if (options?.updatedTreeOrder) {
      nextValue.treeOrder = options.updatedTreeOrder;
    }

    onChange(nextValue);
  };

  const addNewLink = () => {
    if (selectedType?.value === 'page' && !formValues.newPageSelected) {
      toast.error(missingPageSelectionError);
      return;
    }

    const newNavLink: NavLink = {
      id: getNextNavItemId(widgetState.config.menuItems),
      ...getSharedNavItemFields(),
      url: formValues.newUrl,
      type: selectedType?.value,
      isSection: false,
      pageSelected: formValues.newPageSelected,
    };
    const updatedMenuItems = [...widgetState.config.menuItems, newNavLink];
    const updatedTreeOrder = [...widgetState.config.treeOrder, newNavLink.id];
    sortItems(updatedMenuItems, updatedTreeOrder);
    persistMenuItems(updatedMenuItems, {
      updatedTreeOrder,
      changedId: newNavLink.id,
    });
    resetForm();
    resetPopovers();
  };

  const editLink = () => {
    if (formValues.newType === 'page' && !formValues.newPageSelected) {
      toast.error(missingPageSelectionError);
      return;
    }

    const updatedMenuItems = widgetState.config.menuItems.map(item => {
      if (item.id === currentItem.id) {
        return {
          ...item,
          ...getSharedNavItemFields(),
          url: formValues.newUrl,
          type: formValues.newType,
          pageSelected: formValues.newPageSelected,
        };
      }
      return item;
    });

    persistMenuItems(updatedMenuItems, { changedId: currentItem.id });
    resetForm();
    resetPopovers();
  };

  const addNewSection = () => {
    const newSection: NavLink = {
      id: getNextNavItemId(widgetState.config.menuItems),
      ...getSharedNavItemFields(),
      isSection: true,
      childOrder: [],
      expanded: false,
    };
    const updatedMenuItems = [...widgetState.config.menuItems, newSection];
    const updatedTreeOrder = [...widgetState.config.treeOrder, newSection.id];
    sortItems(updatedMenuItems, updatedTreeOrder);
    persistMenuItems(updatedMenuItems, {
      updatedTreeOrder,
      changedId: newSection.id,
    });
    resetForm();
    resetPopovers();
  };

  const editSection = () => {
    const updatedMenuItems = widgetState.config.menuItems.map(item => {
      if (item.id === currentItem.id) {
        return {
          ...item,
          ...getSharedNavItemFields(),
        };
      }
      return item;
    });

    persistMenuItems(updatedMenuItems, { changedId: currentItem.id });
    resetForm();
    resetPopovers();
  };

  const handleVisibleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    updateFormValues({ newVisible: e.target.checked });
  };

  const handleRequiredCheck = (e: ChangeEvent<HTMLInputElement>) => {
    updateFormValues({ newRequired: e.target.checked });
  };

  const handleDelete = () => {
    const {
      menuItems: updatedArray,
      treeOrder: updatedTreeOrder,
    } = removeNavItemWithDescendants(
      widgetState.config.menuItems,
      widgetState.config.treeOrder,
      currentItem.id
    );

    persistMenuItems(updatedArray, {
      updatedTreeOrder,
      changedId: currentItem.id,
    });
    resetPopovers();
    resetForm();
  };

  function handleIconChange(icon: Image) {
    updateFormValues({ newIcon: icon });
  }

  const handleStyleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    updateWidgetConfig({
      height: e.target.value === 'Vertical' ? 300 : 90,
      style: e.target.value,
      enableFullScreen:
        e.target.value === 'Vertical' ? false : value.enableFullScreen,
    });
    if (e.target.value === 'Horizontal') {
      const childWidgets = props.currentPage.content[widgetState.id].children;
      if (childWidgets.length > 0) {
        childWidgets.forEach(childId => removeWidget(childId));
      }
    }
  };

  const handlePageChange = (e: IDropdownItem) => {
    const selectedPageValue = e.value ?? e.id;
    const selectedPageId = Number(selectedPageValue);
    const selectedPage = (pages ?? []).find(
      page => Number(page.id) === selectedPageId
    );

    if (!selectedPage) {
      setPageValue(null);
      updateFormValues({ newPageSelected: null, newUrl: '' });
      toast.error(missingPageSelectionError);
      console.warn('Page not found for selected value:', selectedPageValue);
      return;
    }

    setPageValue(e);
    const pageSlug = selectedPage.current.slug;
    updateFormValues({
      newType: 'page',
      newPageSelected: getMinimalPageReference(selectedPage),
      newUrl: `https://${props.site.domain}/${pageSlug || 'home'}`,
    });
  };

  const handleTextColor = (data: string) => {
    applySolidColorValue('textColor', data, 'text color');
  };

  const handleHoverTextColor = (data: string) => {
    applySolidColorValue('hoverTextColor', data, 'text color');
  };
  const getColorByItemType = (itemType: string): string => {
    switch (itemType) {
      case 'icon':
        return widgetState.config.iconColor;
      case 'divider':
        return widgetState.config.dividerLineColor;
      case 'vertical-divider':
        return widgetState.config.verticalDividerLineColor;
      default:
        return widgetState.config.dividerLineColor;
    }
  };

  const handleDropdownItemsBackgroundColor = (data: string) => {
    updateWidgetConfig({ dropdownItemsBackgroundColor: data });
  };

  const handleFontSize = data => {
    updateWidgetConfig({ fontSize: data });
  };

  const handleFont = data => {
    updateWidgetConfig({ font: data });
  };

  const handleHoverTextColorCheckbox = data => {
    updateWidgetConfig({ isDifferentTextColorOnHover: data });
  };

  const handleBold = data => {
    updateWidgetConfig({ bold: data });
  };

  const handleItalic = data => {
    updateWidgetConfig({ italic: data });
  };

  const handleUnderline = data => {
    updateWidgetConfig({ underline: data });
  };

  const handleStrikeThrough = data => {
    updateWidgetConfig({ strikeThrough: data });
  };

  const handleTreeChange = (item, target) => {
    handleDrop(item, target, props);
  };

  const handleDisplayTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    updateFormValues({ newDisplayText: e.target.value });
  };

  const handleRoutingIdChange = (e: ChangeEvent<HTMLInputElement>) => {
    updateFormValues({
      newRoutingId: e.target.value.toLowerCase().replace(/ +/g, '-'),
    });
  };

  const renderRoutingIdField = (formId: string) => (
    <StyledFormControl id={formId}>
      <StyledFormLabel>Routing ID (optional):</StyledFormLabel>
      <StyledTextInput
        name="routing-id"
        value={formValues.newRoutingId}
        onChange={handleRoutingIdChange}
        placeholder={generateDefaultRoutingId(formValues.newDisplayText || '')}
        data-test-id={`${formId}-input`}
      />
    </StyledFormControl>
  );

  const renderRequiredCheckbox = (testId?: string) => (
    <StyledFormControl id="required-checkbox">
      <StyledRequiredCheckbox
        checked={formValues.newRequired || false}
        onChange={handleRequiredCheck}
        data-test-id={testId}
      >
        Required
      </StyledRequiredCheckbox>
    </StyledFormControl>
  );

  const shouldShowLinkRoutingIdField =
    props.widgetState.config.style === 'Vertical' &&
    selectedType?.value === 'none';

  const shouldShowSectionRoutingIdField =
    props.widgetState.config.style === 'Vertical';

  const renderLinkDestinationFields = ({
    pageFormId,
    pageLabelTestId,
    pageDropdownTestId,
    urlFormId,
    urlLabelTestId,
    urlInputTestId,
  }: {
    pageFormId: string;
    pageLabelTestId: string;
    pageDropdownTestId: string;
    urlFormId: string;
    urlLabelTestId: string;
    urlInputTestId: string;
  }) => {
    if (selectedType?.value === 'page') {
      return (
        <StyledFormControl id={pageFormId}>
          <StyledFormLabel data-test-id={pageLabelTestId}>
            Select a page:
          </StyledFormLabel>
          <StyledDropdown
            type="single"
            onChange={handlePageChange}
            value={pageValue}
            data-test-id={pageDropdownTestId}
            items={pageDropdown}
          ></StyledDropdown>
        </StyledFormControl>
      );
    }

    if (selectedType?.value === 'url') {
      return (
        <StyledFormControl id={urlFormId}>
          <StyledFormLabel data-test-id={urlLabelTestId}>
            Enter a URL:
          </StyledFormLabel>
          <StyledTextInput
            name="webaddress"
            value={formValues.newUrl}
            onChange={handleUrl}
            placeholder="https://..."
            data-test-id={urlInputTestId}
          />
        </StyledFormControl>
      );
    }

    return null;
  };

  const renderIconUploadField = (
    iconUploadLabelTestId: string,
    iconUploadTestId: string
  ) => (
    <>
      <StyledFormLabel data-test-id={iconUploadLabelTestId}>
        Icon:
      </StyledFormLabel>
      <S3ImageControlsWrapper>
        <S3Image
          image={formValues.newIcon}
          label="Click to Upload"
          data-test-id={iconUploadTestId}
          onUpload={handleIconChange}
        />
        <S3ImagePreviewWrapper>
          {formValues.newIcon && (
            <LogoPreview
              url={formValues.newIcon.url}
              maxWidth={50}
              maxHeight={50}
            />
          )}
        </S3ImagePreviewWrapper>
      </S3ImageControlsWrapper>
    </>
  );

  const renderVisibilityAndIdpFields = ({
    visibleFormId,
    visibleLabelTestId,
    visibleCheckboxTestId,
    idpFormId,
    idpLabelTestId,
    idpDropdownTestId,
  }: {
    visibleFormId: string;
    visibleLabelTestId: string;
    visibleCheckboxTestId: string;
    idpFormId: string;
    idpLabelTestId: string;
    idpDropdownTestId: string;
  }) => (
    <>
      <StyledFormControl id={visibleFormId}>
        <StyledFormLabel data-test-id={visibleLabelTestId}>
          Visibility:
        </StyledFormLabel>
        <StyledCheckBox
          checked={formValues.newVisible}
          onChange={handleVisibleCheck}
          data-test-id={visibleCheckboxTestId}
        >
          Visible for all users?
        </StyledCheckBox>
      </StyledFormControl>
      {idpDropdown.length > 0 && !formValues.newVisible && (
        <StyledFormControl id={idpFormId}>
          <StyledFormIDPLabel data-test-id={idpLabelTestId}>
            Item visible for users logged in with these IDPs:
          </StyledFormIDPLabel>
          <StyledDropdown
            type="multi"
            onChange={handleSelectedIdps}
            value={selectedIdps}
            data-test-id={idpDropdownTestId}
            items={idpDropdown}
          />
        </StyledFormControl>
      )}
    </>
  );

  return (
    <Panel.Group data-test-id="nav-widget-control">
      <StyledPanel>
        <Panel
          title={<Label style={StyledPanelTitle}>General</Label>}
          icon={Arrow}
          data-test-id="general-panel"
        >
          <LineDirectionWrapper>
            <Label style={DividerLabelStyle}>Style</Label>
            <FormControl
              data-test-id="nav-orientation-select-dropdown"
              disabled={layoutLocked}
              id="orientation-select"
            >
              <OrientationSelect
                name="navorientation"
                id="nav-orientation-select"
                data-test-id="nav-orientation"
                value={widgetState.config.style}
                onChange={handleStyleChange}
              >
                {lineDirectionOptions.map(d => {
                  return (
                    <option value={d} key={d}>
                      {d}
                    </option>
                  );
                })}
              </OrientationSelect>
            </FormControl>
          </LineDirectionWrapper>
          <ColorButtonAndLabelWrapper>
            <StyledLabel style={ColorLabelStyles}>
              Dropdown icon color
            </StyledLabel>
            <ColorButtonWrapper
              data-test-id="nav-icon-color"
              id="icon-color"
              onClick={e => handleColorEditClick(e, 'icon')}
            >
              <ColorButton
                color={widgetState.config.iconColor}
                disabled={layoutLocked}
              />
            </ColorButtonWrapper>
          </ColorButtonAndLabelWrapper>
          <CheckboxWrapper>
            <InlineMainLabel>Include divider lines</InlineMainLabel>
            <StyledFormControl id="divider-checkbox" disabled={layoutLocked}>
              <StyledCheckbox
                data-test-id="divider-check"
                checked={widgetState.config.showDividerLines}
                onChange={handleDividerCheck}
              />
            </StyledFormControl>
            {widgetState.config.showDividerLines && (
              <ColorButtonWrapper
                data-test-id="divider-color"
                id="divider-color"
                onClick={e => handleColorEditClick(e, 'divider')}
              >
                <ColorButton
                  color={widgetState.config.dividerLineColor}
                  disabled={layoutLocked}
                />
              </ColorButtonWrapper>
            )}
            <StyledPickerPopover
              data-test-id="widget-color-picker-popover"
              id={pickerId}
              open={pickerOpen}
              onClick={handlePickerClick}
              onClose={handlePickerClose}
              anchorEl={pickerAnchorEl}
              anchorOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'center',
                horizontal: 'right',
              }}
            >
              <StyledPickerWrapper>
                <StyledPickerHeader data-test-id="styled-picker-header">
                  Color Selector
                </StyledPickerHeader>
                <StyledClose
                  data-test-id="close-icon"
                  onClick={handlePickerClose}
                />
              </StyledPickerWrapper>
              <GradientColorPicker
                data-test-id="gradient-color-picker"
                value={getColorByItemType(itemType)}
                site={props.site}
                handleColorChange={handleColorChange}
                onChange={handleColorChange}
                updateSite={props.updateSite}
                saveSite={props.saveSite}
                anchorEl={pickerAnchorEl}
              />
            </StyledPickerPopover>
          </CheckboxWrapper>
          {widgetState.config.style === 'Vertical' && (
            <CheckboxWrapper>
              <InlineMainLabel style={{ marginRight: '0' }}>
                Include vertical content divider
              </InlineMainLabel>
              <StyledFormControl id="button-checkbox-1" disabled={layoutLocked}>
                <StyledCheckbox
                  data-test-id="divider-check-vertical"
                  checked={widgetState.config.showVerticalDivider}
                  onChange={handleVerticalDividerCheck}
                />
              </StyledFormControl>
              {widgetState.config.showVerticalDivider && (
                <ColorButtonWrapper
                  data-test-id="vertical-divider-color"
                  id="vertical-divider-color"
                  onClick={e => handleColorEditClick(e, 'vertical-divider')}
                >
                  <ColorButton
                    data-test-id="vertical-divider-color-button"
                    color={widgetState.config.verticalDividerLineColor}
                    disabled={layoutLocked}
                  />
                </ColorButtonWrapper>
              )}
            </CheckboxWrapper>
          )}
          {widgetState.config.style === 'Horizontal' && (
            <EnableFullScreenWidth
              disabled={layoutLocked}
              handleEnableFullScreen={handleFullScreen}
              enableFullScreenWidth={widgetState.config.enableFullScreen}
            />
          )}
          <div style={{ padding: '1rem 0' }}>
            <StyledHeader>Navigation Items</StyledHeader>
            <UncontrolledTreeEnvironment
              data-test-id="nav-tree"
              key={changed}
              viewState={{
                'tree-1': {
                  expandedItems: emptyFolderIds,
                },
              }}
              dataProvider={dataProvider}
              getItemTitle={item => item.data.displayText}
              canDropAt={(items, target) =>
                handleDropRequiredItem(
                  items,
                  target,
                  widgetState.config.menuItems,
                  isEditingTemplate,
                  widgetState.config.treeOrder
                )
              }
              onDrop={(item, target) => handleTreeChange(item, target)}
              canDragAndDrop={true}
              canReorderItems={true}
              canDropOnFolder={true}
              canDrag={items =>
                isEditingTemplate
                  ? true
                  : items.every(item => !item.data.required)
              }
              {...navRenderers}
            >
              <Tree treeId="tree-1" rootItem="root" />
            </UncontrolledTreeEnvironment>
          </div>
          <Divider style={dividerStyles} />
          <StyledEditPopover
            id={editItemId}
            open={editSectionOpen}
            anchorEl={editSectionAnchorEl}
            onClose={handleClose}
            anchorReference="anchorEl"
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            data-test-id="edit-link-popover"
          >
            {!openEditLink && (
              <StyledPage style={StyledNewLink} onClick={handleInputClick}>
                <StyledSettingsCard data-test-id="edit-link-card">
                  <StyledSettingName
                    data-test-id="edit-link-name"
                    onClick={() => {
                      setOpenEditLink(true);
                    }}
                    disabled={!isEditingTemplate && currentItem.required}
                  >
                    <SharedIcon
                      icon="Edit"
                      width={15}
                      style={iconStyle}
                    ></SharedIcon>
                    <StyledTextName>
                      Edit '{currentItem.displayText}'
                    </StyledTextName>
                  </StyledSettingName>

                  <Divider style={settingsDividerStyles}></Divider>
                  <StyledSettingName
                    data-test-id="delete-link"
                    onClick={handleDelete}
                    disabled={!isEditingTemplate && currentItem.required}
                  >
                    <SharedIcon
                      icon="Delete"
                      width={15}
                      style={iconStyle}
                    ></SharedIcon>
                    <StyledTextName>
                      Delete {currentItem.displayText}
                    </StyledTextName>
                  </StyledSettingName>
                </StyledSettingsCard>
              </StyledPage>
            )}
            {openEditLink && isEditingLink && (
              <StyledPage style={StyledNewLink} onClick={handleInputClick}>
                <StyledCard
                  onClick={handleInputClick}
                  data-test-id="editlink-styledcard"
                >
                  <Card
                    header={
                      <Label style={StyledTitle}>
                        Edit '{currentItem.displayText}'
                      </Label>
                    }
                    data-test-id="edit-link-card"
                  >
                    {isEditingTemplate &&
                      renderRequiredCheckbox('edit-link-required-checkbox')}
                    <StyledFormControl id="edit-link-display-text-form">
                      <StyledFormLabel data-test-id="edit-link-display-text-input-label">
                        Display Text:
                      </StyledFormLabel>
                      <StyledTextInput
                        name="display-text"
                        value={formValues.newDisplayText}
                        onChange={handleDisplayTextChange}
                        data-test-id="edit-link-display-text"
                        placeholder="Enter display text"
                      />
                    </StyledFormControl>
                    <StyledFormControl id="edit-link-type-dropdown-form">
                      <StyledFormLabel data-test-id="edit-link-type-dropdown-label">
                        Type:
                      </StyledFormLabel>
                      <StyledDropdown
                        type="single"
                        onChange={setSelectedType}
                        value={selectedType}
                        data-test-id="edit-link-type-dropdown"
                        items={typeDropdown}
                      />
                    </StyledFormControl>
                    {renderLinkDestinationFields({
                      pageFormId: 'edit-link-page-dropdown-form',
                      pageLabelTestId: 'edit-link-page-dropdown-label',
                      pageDropdownTestId: 'edit-link-page-dropdown',
                      urlFormId: 'edit-link-web-address-form',
                      urlLabelTestId: 'edit-link-web-address-label',
                      urlInputTestId: 'edit-link-web-address',
                    })}
                    {shouldShowLinkRoutingIdField && (
                      <>
                        {renderRoutingIdField('edit-link-routing-id-form')}
                        <FieldWrapper>
                          <StyledFormLabel>URL Preview:</StyledFormLabel>
                          <StyledResponse>
                            {generateRoutingSnippet(
                              props.site.domain,
                              props.currentPage?.slug || '',
                              formValues.newRoutingId,
                              getTopLevelParentRoutingId(
                                widgetState.config.menuItems,
                                widgetState.config.menuItems.find(
                                  item => item.id === currentItem.id
                                )?.parentSectionId
                              )
                            )}
                          </StyledResponse>
                        </FieldWrapper>
                      </>
                    )}
                    {renderIconUploadField(
                      'edit-link-icon-upload-label',
                      'edit-link-icon-upload'
                    )}
                    {renderVisibilityAndIdpFields({
                      visibleFormId: 'edit-link-visible-checkbox-form',
                      visibleLabelTestId: 'edit-link-visible-checkbox-label',
                      visibleCheckboxTestId: 'edit-link-visible-checkbox',
                      idpFormId: 'edit-link-pidpdropdown-form',
                      idpLabelTestId: 'edit-link-idp-dropdown-label',
                      idpDropdownTestId: 'edit-link-idp-dropdown',
                    })}
                    <ButtonWrapper1>
                      <StyledAlternativeButton
                        variant="secondary"
                        onClick={() => {
                          setOpenEditLink(false);
                        }}
                        size="s"
                        data-test-id="new-link-previous-button"
                      >
                        Previous
                      </StyledAlternativeButton>
                      <Button
                        onPress={editLink}
                        data-test-id="new-link-save-button"
                      >
                        Apply changes
                      </Button>
                      <Button
                        variant="tertiary"
                        onClick={resetPopovers}
                        className="mt-base"
                        data-test-id="advanced-popover-cancel-button"
                      >
                        Cancel
                      </Button>
                    </ButtonWrapper1>
                  </Card>
                </StyledCard>
              </StyledPage>
            )}
            {openEditLink && isEditingSection && (
              <StyledPage onClick={handleInputClick}>
                <StyledCard
                  onClick={handleInputClick}
                  data-test-id="edit-section-styledcard"
                >
                  <Card
                    header={
                      <Label style={StyledTitle}>
                        Edit '{currentItem.displayText}'
                      </Label>
                    }
                    data-test-id="edit-section-card"
                  >
                    {isEditingTemplate && renderRequiredCheckbox()}
                    <StyledDiv>
                      <StyledFormControl id="edit-section-display-text-form">
                        <StyledFormLabel data-test-id="edit-section-display-text-input-label">
                          Display Text:
                        </StyledFormLabel>
                        <StyledTextInput
                          name="display-text"
                          value={formValues.newDisplayText}
                          onChange={handleDisplayTextChange}
                          data-test-id="edit-section-web-address"
                        />
                      </StyledFormControl>
                    </StyledDiv>
                    {shouldShowSectionRoutingIdField &&
                      renderRoutingIdField('edit-section-routing-id-form')}
                    <StyledDiv>
                      {renderIconUploadField(
                        'edit-section-icon-upload-label',
                        'edit-section-icon-image'
                      )}
                      {renderVisibilityAndIdpFields({
                        visibleFormId: 'edit-section-visible-checkbox-form',
                        visibleLabelTestId:
                          'edit-section-visible-checkbox-label',
                        visibleCheckboxTestId: 'edit-section-visible-checkbox',
                        idpFormId: 'edit-section-idp-dropdown-form',
                        idpLabelTestId: 'edit-section-idp-dropdown-label',
                        idpDropdownTestId: 'edit-section-idp-dropdown',
                      })}
                    </StyledDiv>
                    <ButtonWrapperFolder>
                      <StyledAlternativeButton
                        variant="secondary"
                        onClick={closePanel}
                        size="s"
                        data-test-id="previous-button"
                      >
                        Previous
                      </StyledAlternativeButton>
                      <Button onPress={editSection} data-test-id="save-button">
                        Apply changes
                      </Button>
                      <Button
                        variant="tertiary"
                        onClick={handleClose}
                        size="m"
                        className="mt-base"
                        data-test-id="popover-cancel-button"
                      >
                        Cancel
                      </Button>
                    </ButtonWrapperFolder>
                  </Card>
                </StyledCard>
              </StyledPage>
            )}
          </StyledEditPopover>
          <StyledAddItemButton
            variant="secondary"
            onClick={handleClick}
            icon={<AddIcon />}
            data-test-id="add-link-button"
          >
            Add an Item
          </StyledAddItemButton>
          <StyledPopover
            id={id}
            open={createLinkOpen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorPosition={{ top: 0, left: 0 }}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            data-test-id="add-link-popover"
          >
            {openPopover.linkForm === false && (
              <StyledPage onClick={handleInputClick}>
                <StyledCard
                  style={{ width: '20em' }}
                  onClick={handleInputClick}
                  data-test-id="add-item-card"
                >
                  <Card
                    header={<Label style={StyledTitle}>Add New Nav Item</Label>}
                    data-test-id="add-item-card"
                  >
                    <SecondaryFormControl id="radio-groups-controlled">
                      <StyledRadioButton
                        name="radio-groups-controlled"
                        value="New Link"
                        onChange={setValue}
                        checked={checked === 'New Link'}
                        aria-label="Add Link"
                        aria-checked={checked === 'New Link'}
                        data-test-id="new-link-radiobutton"
                      >
                        {Form}
                        <span>
                          Add Link
                          <StyledSubtext>
                            Add a link to an internal page or an external URL.
                          </StyledSubtext>
                        </span>
                      </StyledRadioButton>

                      <StyledRadioButton
                        name="radio-groups-controlled"
                        value="New Section"
                        onChange={setValue}
                        checked={checked === 'New Section'}
                        aria-label="Add Section"
                        aria-checked={checked === 'New Section'}
                        data-test-id="new-section-radiobutton"
                      >
                        <span>
                          Add Section
                          <StyledSubtext>
                            Create a scaffolding section that can contain
                            multiple links.
                          </StyledSubtext>
                        </span>
                      </StyledRadioButton>
                    </SecondaryFormControl>
                    <ButtonWrapper>
                      <Button onClick={openPanel} data-test-id="next-button">
                        Next
                      </Button>
                      <Button
                        variant="tertiary"
                        onClick={handleClose}
                        className="mt-base"
                        data-test-id="cancel-button"
                      >
                        Cancel
                      </Button>
                    </ButtonWrapper>
                  </Card>
                </StyledCard>
              </StyledPage>
            )}
            {openPopover.linkForm && checked === 'New Link' && (
              <StyledPage onClick={handleInputClick}>
                <StyledCard
                  onClick={handleInputClick}
                  data-test-id="add-newpage-styledcard"
                >
                  <Card
                    header={<Label style={StyledTitle}>Add a new link</Label>}
                    data-test-id="add-newpage-card"
                  >
                    {isEditingTemplate &&
                      renderRequiredCheckbox('add-link-required-checkbox')}
                    <StyledFormControl id="add-link-display-text-form">
                      <StyledFormLabel data-test-id="add-link-display-text-input-label">
                        Display Text:
                      </StyledFormLabel>
                      <StyledTextInput
                        name="display-text"
                        value={formValues.newDisplayText}
                        onChange={handleDisplayTextChange}
                        data-test-id="add-link-display-text-input"
                      />
                    </StyledFormControl>
                    <StyledDiv>
                      <StyledFormControl
                        id="add-link-type-select"
                        data-test-id="add-link-type-dropdown-form"
                      >
                        <StyledFormLabel data-test-id="add-link-type-dropdown-label">
                          Type:
                        </StyledFormLabel>
                        <StyledDropdown
                          type="single"
                          onChange={setSelectedType}
                          value={selectedType}
                          data-test-id="add-link-type-dropdown"
                          items={typeDropdown}
                        />
                      </StyledFormControl>
                    </StyledDiv>
                    {renderLinkDestinationFields({
                      pageFormId: 'add-link-page-dropdown-form',
                      pageLabelTestId: 'add-link-page-dropdown-label',
                      pageDropdownTestId: 'add-link-page-dropdown',
                      urlFormId: 'add-link-web-address-form',
                      urlLabelTestId: 'add-link-web-address-label',
                      urlInputTestId: 'add-link-web-address',
                    })}
                    {shouldShowLinkRoutingIdField &&
                      renderRoutingIdField('add-link-routing-id-form')}
                    {renderIconUploadField(
                      'add-link-icon-upload-label',
                      'add-link-icon-upload'
                    )}
                    {renderVisibilityAndIdpFields({
                      visibleFormId: 'add-link-visible-checkbox-form',
                      visibleLabelTestId: 'add-link-visible-checkbox-label',
                      visibleCheckboxTestId: 'add-link-visible-checkbox',
                      idpFormId: 'add-link-page-dropdown-form',
                      idpLabelTestId: 'add-link-page-dropdown-label',
                      idpDropdownTestId: 'add-link-page-dropdown',
                    })}
                    <ButtonWrapper1>
                      <StyledAlternativeButton
                        variant="secondary"
                        onClick={closePanel}
                        size="s"
                        data-test-id="previous-button"
                      >
                        Previous
                      </StyledAlternativeButton>
                      <Button
                        onPress={addNewLink}
                        data-test-id="save-link-button"
                      >
                        Apply changes
                      </Button>
                      <Button
                        variant="tertiary"
                        onClick={handleClose}
                        className="mt-base"
                        data-test-id="popover-cancel-button"
                      >
                        Cancel
                      </Button>
                    </ButtonWrapper1>
                  </Card>
                </StyledCard>
              </StyledPage>
            )}
            {openPopover.linkForm && checked !== 'New Link' && (
              <StyledPage onClick={handleInputClick}>
                <StyledCard
                  onClick={handleInputClick}
                  data-test-id="add-new-section-styledcard"
                >
                  <Card
                    header={
                      <Label style={StyledTitle}>Add a new section</Label>
                    }
                    data-test-id="add-new-section-card"
                  >
                    <StyledDiv>
                      <StyledFormControl id="add-section-display-text-form">
                        <StyledFormLabel data-test-id="add-section-display-text-input-label">
                          Display Text:
                        </StyledFormLabel>
                        <StyledTextInput
                          name="display-text"
                          value={formValues.newDisplayText}
                          onChange={handleDisplayTextChange}
                          data-test-id="add-section-display-text-input"
                        />
                      </StyledFormControl>
                      {isEditingTemplate && renderRequiredCheckbox()}
                    </StyledDiv>
                    {shouldShowSectionRoutingIdField &&
                      renderRoutingIdField('add-section-routing-id-form')}
                    <StyledDiv>
                      {renderIconUploadField(
                        'add-section-icon-upload-label',
                        'add-section-icon-upload'
                      )}
                      {renderVisibilityAndIdpFields({
                        visibleFormId: 'visible-checkbox',
                        visibleLabelTestId:
                          'add-section-visible-checkbox-label',
                        visibleCheckboxTestId: 'add-section-visible-checkbox',
                        idpFormId: 'add-section-idp-dropdown-form',
                        idpLabelTestId: 'add-section-idp-dropdown-label',
                        idpDropdownTestId: 'add-section-idp-select-dropdown',
                      })}
                    </StyledDiv>
                    <ButtonWrapperFolder>
                      <StyledAlternativeButton
                        variant="secondary"
                        onClick={closePanel}
                        size="s"
                        data-test-id="previous-button"
                      >
                        Previous
                      </StyledAlternativeButton>
                      <Button
                        onPress={addNewSection}
                        data-test-id="save-button"
                      >
                        Apply changes
                      </Button>
                      <Button
                        variant="tertiary"
                        onClick={handleClose}
                        size="m"
                        className="mt-base"
                        data-test-id="popover-cancel-button"
                      >
                        Cancel
                      </Button>
                    </ButtonWrapperFolder>
                  </Card>
                </StyledCard>
              </StyledPage>
            )}
          </StyledPopover>
        </Panel>
      </StyledPanel>
      <StyledPanel data-testid="styles-config-panel">
        <Panel
          title={<Label style={StyledPanelTitle}>Typography</Label>}
          initiallyClosed
          icon={Arrow}
          data-test-id="typography-panel"
        >
          <NavigationTypography
            data-test-id="nav-typography-component"
            disabled={layoutLocked}
            color={widgetState.config.textColor}
            widgetState={props.widgetState}
            handleBold={handleBold}
            handleItalic={handleItalic}
            handleUnderline={handleUnderline}
            handleStrikeThrough={handleStrikeThrough}
            handleFontSize={handleFontSize}
            handleFont={handleFont}
            handleTextColor={handleTextColor}
            handleHoverTextColor={handleHoverTextColor}
            handleHoverTextColorCheckbox={handleHoverTextColorCheckbox}
            pages={pages}
            site={props.site}
            updateSite={props.updateSite}
            saveSite={props.saveSite}
            hideTextColor={true}
          />
        </Panel>
      </StyledPanel>
      <StyledPanel>
        <SizeLocationPanel
          title={<Label style={StyledPanelTitle}>Size and Location</Label>}
          initiallyClosed
          icon={Arrow}
          data-testid="sizeandlocation-panel"
        >
          <WidgetSizeLocation
            data-test-id="widget-size-location"
            disabled={layoutLocked}
            activeWidgetId={props.widgetState.id}
            sizeLocation={{
              xLocation: value.xLocation,
              yLocation: value.yLocation,
              width: value.width,
              height: value.height,
              uniqueId: value.uniqueId,
            }}
            updateWidgetSizeLocation={updateWidgetSizeLocation}
          />
        </SizeLocationPanel>
      </StyledPanel>
      <StyledPanel>
        <Panel
          title={<Label style={StyledPanelTitle}>Background</Label>}
          initiallyClosed
          icon={Arrow}
          data-test-id="background-panel"
        >
          <Background
            data-test-id="background-component"
            disabled={layoutLocked}
            backgroundData={backgroundData}
            backgroundImage={updateBackgroundImage}
            handleBackgroundColor={handleBackgroundColor}
            handleDropdownItemsBackgroundColor={
              handleDropdownItemsBackgroundColor
            }
            saveSite={props.saveSite}
            updateSite={props.updateSite}
            site={props.site}
            widgetState={widgetState}
          />
        </Panel>
      </StyledPanel>
      <StyledPanel>
        <Panel
          title={<Label style={StyledPanelTitle}>Border</Label>}
          initiallyClosed
          icon={Arrow}
          data-test-id="border-panel"
        >
          <Border
            data-test-id="border-component"
            disabled={layoutLocked}
            updateBorderData={updateBorderData}
            handleLineColor={handleLineColor}
            widgetState={widgetState}
            pages={props.pages}
            site={props.site}
            updateSite={props.updateSite}
            saveSite={props.saveSite}
          />
        </Panel>
      </StyledPanel>
      <StyledPanel>
        <Panel
          title={<Label style={StyledPanelTitle}>Padding</Label>}
          initiallyClosed
          icon={Arrow}
        >
          <Padding
            data-test-id="padding-data"
            disabled={layoutLocked}
            paddingData={updatePaddingData}
            widgetState={widgetState}
          />
        </Panel>
      </StyledPanel>
    </Panel.Group>
  );
};

export default NavWidgetControl;
